'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OrderDialog = exports.SelectInput = exports.GroupSelect = exports.CitySelect = exports.TablePlus = undefined;

var _tablePlus = require('./components/table-plus');

var _tablePlus2 = _interopRequireDefault(_tablePlus);

var _citySelect = require('./components/city-select');

var _citySelect2 = _interopRequireDefault(_citySelect);

var _groupSelect = require('./components/group-select');

var _groupSelect2 = _interopRequireDefault(_groupSelect);

var _selectInput = require('./components/select-input');

var _selectInput2 = _interopRequireDefault(_selectInput);

var _orderDialog = require('./components/order-dialog');

var _orderDialog2 = _interopRequireDefault(_orderDialog);

var _imgViewer = require('./directives/img-viewer');

var _imgViewer2 = _interopRequireDefault(_imgViewer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var components = [_tablePlus2.default, _citySelect2.default, _groupSelect2.default, _selectInput2.default, _orderDialog2.default];
var install = function install(Vue) {
  components.forEach(function (component) {
    Vue.component(component.name, component);
  });
  (0, _imgViewer2.default)(Vue);
};

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
};

exports.TablePlus = _tablePlus2.default;
exports.CitySelect = _citySelect2.default;
exports.GroupSelect = _groupSelect2.default;
exports.SelectInput = _selectInput2.default;
exports.OrderDialog = _orderDialog2.default;
exports.default = {
  install: install
};


//////////////////
// WEBPACK FOOTER
// ./~/@ele/lpd-component/lib/index.js
// module id = 282
// module chunks = 0